import frameworkRoutes from './frameworks';
import municipalityRoutes from './municipalities';
import settingRoutes from './settings';
import userRoutes from './users';

export default [
  ...frameworkRoutes,
  ...municipalityRoutes,
  ...settingRoutes,
  ...userRoutes,
];
